module.exports = __webpack_public_path__ + "img/bus-journey.af43180b.webp";